<template>
	<div class="click-splash-screen" v-if="!isSiteStatusCalled">
		<div class="click-logo-sec shiny-cta">
			<img v-if="siteLogo" :src="siteLogo" alt="logo" title="siteLogo" loading="lazy" />
		</div>
	</div>
	<router-view v-if="(['virtual-sport', 'sports-book', 'PageNotFound', 'fantasy'].includes($route?.name) || lpRoutes.includes($route?.path)) && isSiteStatusCalled" />
	<template v-else-if="isSiteStatusCalled">

		<Header v-if="!WalletRoutes.includes($route?.name) && !underMaintenance" />
		<SportSelection ref="sportselection" v-if="checkRoutes() && !WalletRoutes.includes($route?.name) && !this.$route.params.is_pool && !underMaintenance" />

		<router-view />
		<MobileFooter v-if="$route?.name != 'Chats' && showMobileFooter() && !this.$route.params.is_pool && !underMaintenance" />

			
			
	</template>
	<FooterContent v-if="showFooterContent" />
	<HomeFooter  v-if="$route?.name === 'Home'" />
	<div class="loader_container" v-if="globalLoader">
        <div class="box">
            <div class="loader"></div>
        </div>
    </div>
	<Offers v-if="$siteSettings?.data?.offer?.image" />
	<div v-if="successMsg && $route.path == '/register' && $siteSettings.data.is_landing_page" style="z-index: 9999;" id="successfullyModal" class="show successfully-wrapper">
		<SuccessModal :message="successMsg" />
	</div>
	<ChangeAndWithdrawPasswordModal/>
    <!-- <UserIdModal/> -->
	<AndroidBanner/>
	 <DownloadApkModal />
	 <DomainSwitchModal :DomainSwitchPoster="DomainSwitchPoster" v-if="DomainSwitchPoster?.image" />
	 <SpinWheel ref="SpinWheelRef" />
	 <div v-if="successMsg" style="z-index: 99999;" id="successfullyModal" class="show successfully-wrapper">
		<SuccessModal :message="successMsg" />
	 </div>

	 <div v-if="errorMsg" style="z-index: 99999;" id="wrongtoaster" class="show successfully-wrapper">
		<ErrorModal :message="errorMsg" />
	 </div>

</template>

<script>

import { AUTH_TOKEN, createComputedPropertiesForApp } from "@template/utils";
import { defineAsyncComponent } from 'vue';
import confetti from "canvas-confetti";
import { setHeaders, setonScroll, getSiteVersion, socketAllEvents, getSpinBonusData, createComputedPropertiesForPostersAndLogos, createSharedComputedPropertiesForSpinWheelBonus, shouldShowFooterContent } from '@template/utils';
import { mapGetters } from 'vuex';
import GamesIframe from '@/shared/components/games/GamesIframe.vue';
import GamePop1 from '@/shared/components/games/GamePop1.vue';
import GamePop2 from '@/shared/components/games/GamePop2.vue';
import { useRouteHead } from '@template/utils'
export default {
	name: "App",
	setup() {
		useRouteHead();
	},
	components: {
		Header: defineAsyncComponent(() =>
			import('./shared/components/header/Header.vue')
		),
		SportSelection: defineAsyncComponent(() =>
			import('./shared/components/sport-selection/SportSelection.vue')
		),
		MobileFooter: defineAsyncComponent(() =>
			import('./shared/components/footer/MobileFooter.vue')
		),
		SuccessModal: defineAsyncComponent(() =>
			import('@/shared/components/modal/SuccessModal.vue')
		),
		ErrorModal: defineAsyncComponent(() =>
			import('@/shared/components/modal/ErrorModal.vue')
		),
		ChangeAndWithdrawPasswordModal: defineAsyncComponent(() =>
			import('@/shared/components/modal/ChangeAndWithdrawPasswordModal.vue')
		),
		Offers: defineAsyncComponent(() =>
			import('./shared/components/header/Offers.vue')
		),
        // UserIdModal: defineAsyncComponent(() =>
		// 	import('@/shared/components/modal/UserIdModal.vue')
		// ),
		AndroidBanner :defineAsyncComponent(() =>
			import('@/shared/components/header/AndroidBanner.vue')),
		DownloadApkModal: defineAsyncComponent(() =>
			import('@/shared/components/modal/DownloadApkModal.vue')
		),
		SpinWheel: defineAsyncComponent(() =>
			import('@/modules/SpinWheel/components/SpinWheel.vue')
		),
		DomainSwitchModal: defineAsyncComponent(() =>
			import('@/shared/components/modal/DomainSwitchModal.vue')
		),
		FooterContent: defineAsyncComponent(() => 
			import('@/shared/components/footer/FooterContent.vue')),
		HomeFooter: defineAsyncComponent(() =>
			import('@/shared/components/footer/Footer.vue')
		),
	},
	data() {
		return {
			interval:null,
			onLine: navigator.onLine,
			showBackOnline: false,
			refreshInit: true,
			scY: 0,
			showGoToTop: false,
			lpRoutes: ['/login', '/register', '/forgot-password', '/'],
			WalletRoutes:[
				'Wallet',
				'WalletDeposit',
				'WalletWithdraw',
				'WalletHistory',
				'TransactionDetails',
				'DepositPaymentMethod',
				'WithdrawDetails',
				'WithdrawAccountDetails',
				'Chats'
			],
			isSiteStatusCalled: false,
		}
	},
	computed: {
		...mapGetters(['successMsg', 'errorMsg', 'siteVersion', 'siteSettings', 'underMaintenance', 'globalLoader','logInData','count','userSpinData','bonusData']),
		...{},
		isHomePage() {
			return this.$route.name === 'Home'
		},
		showFooterContent() {
			const excludedNames = ['PageNotFound','Maintenance','Login','SignUp','ForgotPassword'];
			return shouldShowFooterContent(excludedNames)
		},
	},
	updated() {
		document.body.classList.toggle('nw-bottom-flow-css', !this.isHomePage)
	},
	beforeCreate() {
        let {SpinBonusData} = createSharedComputedPropertiesForSpinWheelBonus(this)
        this.$helper.applySharedComputed(this, {SpinBonusData})

        let {siteLogo} = createComputedPropertiesForPostersAndLogos(this)
        this.$helper.applySharedComputed(this, {siteLogo})

		const { DomainSwitchPoster  } = createComputedPropertiesForApp(this);
		this.$helper.applySharedComputed(this, { DomainSwitchPoster });
    },
	beforeUnmount() {
		clearInterval(this.interval);
		document.body.classList.remove('nw-bottom-flow-css')
	},
	mounted() {
		// prasun.showPrasun();
		window.store = this.$store;
		window.cookies = this.$cookies;
		window.router = this.$router;
		window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
		setHeaders();

		window.addEventListener('online', this.updateOnlineStatus);
		window.addEventListener('offline', this.updateOnlineStatus);
		window.addEventListener('scroll', this.onScroll);
		this.$errorToast(null);
		this.$successToast(null);
		this.$store.dispatch('setGlobalLoader', false);
		this.getSiteVersion();
		socketAllEvents();
		if(this.$auth.status) {
			this.$loadCasinoGame.setComponents({
				GamesIframe,
				GamePop1,
				GamePop2,
			})
		}
	    document.body.classList.toggle('nw-bottom-flow-css', !this.isHomePage)
	},
	methods: {
		async getSiteVersion() {
			try {
				let response = await getSiteVersion(this.siteVersion, this.siteSettings, this.isSiteStatusCalled,true,this.resetWheel);
				this.isSiteStatusCalled = response.isSiteStatusCalled;
				if(response.isMaintenance) {
					this.$store.dispatch('setGlobalLoader', false)
					this.$router.push({ name: 'Maintenance' });
					return;
				};
				if (this.$siteSettings?.data?.languagesList) {
					this.$setCurrentLangData(this.$siteSettings?.data?.languagesList, this.$siteSettings?.data?.language_code, true, this.$siteSettings?.data?.aws_url)
				}
				if (this.$siteSettings.data.is_landing_page && !this.$auth.status && !this.lpRoutes.includes(this.$route.path)) {
					this.$router.push({ name: 'LandingPage' });
				} else if(this.$route.name == 'LandingPage' && !this.$siteSettings?.data?.is_landing_page){
					this.$router.push({ name: 'Home' });
				};
				
				if (this.$auth.status) {
					if (!this.$auth?.user?.last_login_at) {
						this.$helper.openModal("#ChangeAndWithdrawPassword");
						return;
					} else {
						this.handleUserIdAndOffer();
						if(!this.userSpinData && !this.$auth.user?.isDemo && this.SpinBonusData && this.$siteSettings?.data?.business_type == 2){
							const data = await getSpinBonusData();
							if(data?.available_spins && data?.today_remaining_spin_limit){
								this.$helper.openModal('#spin-wheel')
							}else{
								this.$router.push({name:'Home'});
							}
						}
					}
				}
			} catch (error){
				console.log(error)
				if (error) {
					this.$errorToast(error[0]);
				}
			};
		},
		resetWheel() {
			if (this.$refs?.SpinWheelRef?.resetSpinWheel) {
                this.$refs.SpinWheelRef.resetSpinWheel();
            }
		},
		callAnimation(){
			let duration = 1000;
			let end = Date.now() + duration;
			function frame() {
				confetti({
					particleCount: 7,
					angle: 60,
					spread: 55,
					origin: { x: 0 },
				});
				confetti({
					particleCount: 7,
					angle: 120,
					spread: 55,
					origin: { x: 1 },
				});

				if (Date.now() < end) {
					requestAnimationFrame(frame);
				}
			}

			frame(); 
		},
		handleUserIdAndOffer(){
			this.handleOffer();
		},
		handleOffer(){
			let is_offer = this.$store.getters.is_offer;
			if (this.$auth.status && this.$siteSettings.data.offer != null && is_offer && this.$siteSettings?.data?.business_type == 2) {
				this.$helper.openModal("#offer_pop_up");
			}
		},
		onScroll() {
			if (this.scTimer) return;
			let response = setonScroll();
			this.scTimer = response.scTimer;
			this.scY = response.scY;
			this.showGoToTop = response.showGoToTop;
		},
		checkRoutes() {
			let routeName = this.$route?.name;
			let notAllowedROute = [
				'bonus',
				'racing-carousel',
				'racing-category',
				'racing-list-details',
				'notifications',
				'refer-earn',
				'AffDashboard',
				'AffUsersList',
				'AffProfitLoss',
				'AffStatement',
				'AffReports',
				'UserProfitLoss',
				'MyContests',
				'MatchDetails',
				'MyTeams',
				'MatkaDetails',
				'bets',
				'profit-loss',
				'UserProfitLossDetails',
				'HorseRacing',
				'HorseRaceEventDetails',
				'DownloadApk'
			];
			return !notAllowedROute.includes(routeName);
		},
		updateOnlineStatus(e) {
			const {
				type
			} = e;
			this.onLine = type === 'online';
		},
		showMobileFooter() {
			let restrictRoutes = [
				'MyContests',
				'MatchDetails',
				'MyTeams',
				'AffDashboard',
				'AffUsersList',
				'AffProfitLoss',
				'AffStatement',
				'AffReports',
				'UserProfitLoss',
				'MatkaDetails',
				'UserProfitLossDetails',
				'DownloadApk'
			];
			return !restrictRoutes.includes(this.$route?.name);
		},
	},
	watch: {
		onLine(v) {
			if (v) {
				this.showBackOnline = true;
				setTimeout(() => {
					this.showBackOnline = false;
				}, 1000);
			}
		}
	}
};
</script>
